import { render, staticRenderFns } from "./CancelarTotalPrestamo.vue?vue&type=template&id=57ce7700&"
import script from "./CancelarTotalPrestamo.vue?vue&type=script&lang=js&"
export * from "./CancelarTotalPrestamo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports